import React from "react";
import { avatarAtomFamily } from "../jotai/atoms";
import { useAtom } from "jotai";
import { avatars } from "../utils/data";
import { Spinner } from "./spinner/Spinner";

export default function Avatar({ recordId, loading }: { recordId: string; loading?: boolean }) {
  const [avatarId] = useAtom(avatarAtomFamily(recordId));

  if (!avatarId || !avatars.get(avatarId)) {
    return (
      <div className="relative">
        <img className={`${loading ? "opacity-20" : ""}`} src="/assets/images/user.png" />
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <Spinner />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="relative">
      <img className={`${loading ? "opacity-20" : ""}`} src={avatars.get(avatarId)} />
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Spinner />
        </div>
      )}
    </div>
  );
}
